import { z } from 'zod';
import { shiftParticipantHoursHistoryStatus } from '../entities/shiftParticipantHoursHistoryTypes';
const filterDataSchema = z.object({
    search: z.string().optional(),
    status: z.enum(shiftParticipantHoursHistoryStatus).array().optional(),
    dateRange: z
        .object({
        from: z.string().optional(),
        to: z.string().optional(),
    })
        .optional(),
    showPendingOnly: z.boolean().optional(),
});
export const getEligiblePastShiftsByMissionIdRequestSchema = z.object({
    filterData: filterDataSchema,
    missionId: z.string().uuid().optional(),
    isVolunteerView: z.boolean().optional(),
    offset: z.number(),
    limit: z.number(),
});
export const getEligiblePastShiftsByMissionIdResponseSchema = z.object({
    rows: z.any().array(),
    total: z.number(),
    analytics: z.object({
        totalPendingHours: z.number(),
    }),
});
export const partialGetEligiblePastShiftsByMissionIdResponseSchema = getEligiblePastShiftsByMissionIdResponseSchema.omit({ rows: true });
export const getEligiblePastShiftsByMissionIdFunctionDef = {
    name: 'getEligiblePastShiftsByMissionId',
    requestSchema: getEligiblePastShiftsByMissionIdRequestSchema,
    responseSchema: getEligiblePastShiftsByMissionIdResponseSchema,
};
